import React from 'react';
import { motion } from 'framer-motion';
import { TicketIcon, ArrowRightIcon, SparklesIcon } from 'lucide-react';
import { useLanguage } from './LanguageContext';
// TODO: replace with actual Ticketplate event URL when available
const TICKET_URL = 'https://ticketplate.com/checkout/como-la-flor-selena-tribute-2608151900';
export function FeaturedEvent() {
  const {
    t
  } = useLanguage();
  return <section className="relative py-20 md:py-28 bg-ink overflow-hidden" data-id="element-88">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_30%_50%,_rgba(212,164,55,0.10),_transparent_60%)] pointer-events-none" data-id="element-89" />

      <div className="relative max-w-6xl mx-auto px-6 lg:px-10" data-id="element-90">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.6
      }} className="grid md:grid-cols-2 gap-10 lg:gap-16 items-center" data-id="element-91">
          {/* Poster */}
          <div className="relative mx-auto md:mx-0 max-w-sm w-full" data-id="element-92">
            <div className="absolute -inset-3 border border-gold/30 rounded-sm" data-id="element-93" />
            <div className="absolute -inset-3 border border-gold/10 rounded-sm translate-x-3 translate-y-3" data-id="element-94" />
            <div className="relative overflow-hidden rounded-sm shadow-2xl shadow-gold/10" data-id="element-95">
              <img src="https://cdn.magicpatterns.com/uploads/pkY8LscMeeePLkeeV8SqcH/WhatsApp_Image_2026-05-12_at_5.21.55_PM.jpg" alt="Selena — Como La Flor Tribute Live Show" className="w-full h-auto object-cover" data-id="element-96" />
            </div>
          </div>

          {/* Details */}
          <div data-id="element-97">
            <div className="inline-flex items-center gap-2 mb-5 text-gold text-xs tracking-[0.3em]" data-id="element-98">
              <SparklesIcon size={14} data-id="element-99" />
              {t('event.eyebrow')}
            </div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-cream leading-[1.05] mb-4" data-id="element-100">
              {t('event.title.1')}{' '}
              <span className="italic gold-text" data-id="element-101">{t('event.title.2')}</span>
            </h2>
            <p className="font-display italic text-gold text-lg md:text-xl mb-6" data-id="element-102">
              {t('event.subtitle')}
            </p>
            <p className="text-cream/70 text-base md:text-lg leading-relaxed mb-8 max-w-lg" data-id="element-103">
              {t('event.desc')}
            </p>

            <div className="flex flex-wrap gap-3" data-id="element-104">
              <a href={TICKET_URL} target="_blank" rel="noopener noreferrer" className="group inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-gold text-ink font-medium hover:bg-gold-light transition-colors" data-id="element-105">
                <TicketIcon size={18} data-id="element-106" />
                {t('event.cta')}
                <ArrowRightIcon size={16} className="group-hover:translate-x-1 transition-transform" data-id="element-107" />
              </a>
              <a href="#contacto" className="inline-flex items-center px-7 py-3.5 rounded-full border border-gold/40 text-cream hover:border-gold hover:bg-gold/5 transition-colors" data-id="element-108">
                {t('event.info')}
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}